import type { Locale } from "@/lib/i18n";
import { pl, type WLatestBlogPostsTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const wLatestBlogPostsTranslations: Record<Locale, WLatestBlogPostsTranslations> = {
  pl,
  en,
  de,
};

export type { WLatestBlogPostsTranslations };
